<template>
  <!-- 直播投后数据报告 -->
  <div>
    <contenr/>
    <div class="page">
    <div class="detailContainer">
      <div class="part part1">
        <span class="topName">投后数据报告</span>
        <div class="infoText orderInfo">订单号：{{ cooperate.sericnum ||'-'}} | 发布时间：{{ cooperate.release_at||'-'}}</div>
        <div class="infoContent">
          <a class="backImg" :href="baseInfo.item.url||''" target="_blank">
              <img :src="baseInfo.item.cover_image_uri||''" alt="">
          </a>
          <div class="contentDetail">
            <div class="leftBox">
              <div class="contentTitle">{{baseInfo.item.title||'-'}}</div>
              <div class="infoText">任务ID：{{baseInfo.order.id||'-'}}│{{ create_timestamp }}</div>
              <div class="headSculpture">
                <img :src="baseInfo.author.avatar_uri||''" alt="">
                <span class="nickname">{{ baseInfo.author.nick_name||'-' }}</span>
              </div>
            </div>
            <div class="rigthBox">
              <div class="contentBottom">
                <div class="infoItem">
                  <div>累计观看人数</div>
                  <div class="account">{{ fmt(transform['live.spread.watch_uv'], {micrometer: true})||'-' }}</div>
                  <div class="scale">超过<span class="rate">{{fmt(transform['live.spread.watch_uv_industry_over']*100, {micrometer: true})||'-'}}%</span>同行订单</div>
                </div>
                <div class="infoItem">
                  <div>最高在线人数</div>
                  <div class="account">{{ fmt(transform['live.spread.watch_uv_max'], {micrometer: true})||'-' }}</div>
                  <div class="scale">超过<span class="rate">{{fmt(transform['live.spread.watch_uv_max_industry_over']*100, {micrometer: true})||'-'}}%</span>同行订单</div>
                </div>
                <div class="infoItem">
                  <div>组件点击量</div>
                  <div class="account">{{ fmt(transform['live.convert.component_click_cnt'], {micrometer: true})||'-' }}</div>
                  <div class="scale">超过<span class="rate">{{fmt(transform['live.convert.component_click_cnt_industry_over']*100, {micrometer: true})||'-'}}%</span>同行订单</div>
                </div>
                <div class="infoItem">
                  <div>APP安装量</div>
                  <div class="account">{{ fmt(transform['live.convert.app_install_finish_cnt'], {micrometer: true})||'-' }}</div>
                  <div class="scale">超过<span class="rate">{{fmt(transform['live.convert.app_install_finish_cnt_industry_over']*100, {micrometer: true})||'-'}}%</span>同行订单</div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="grade" id="cooperate">
          <span class="title">合作评价</span>
          <div class="gradeContent">
            <!-- <div class="scort">
              <el-rate
                v-model="cooperate.score"
                disabled
                show-score
                text-color="#ff9900">
              </el-rate>
            </div> -->
            <div class="tags2">
              <div class="tagItem">
                <span>内容质量：</span>
                <img v-if="cooperate.quality==='不满意'" src="./images/comment1.png" alt=""/>
                <img v-if="cooperate.quality==='需关注'" src="./images/comment2.png" alt=""/>
                <img v-if="cooperate.quality==='很满意'" src="./images/comment3.png" alt=""/>
                <span>{{cooperate.quality}}</span>
              </div>
              <div class="tagItem">
                <span>合作体验：</span>
                <img v-if="cooperate.experience==='不满意'" src="./images/comment1.png" alt=""/>
                <img v-if="cooperate.experience==='需关注'" src="./images/comment2.png" alt=""/>
                <img v-if="cooperate.experience==='很满意'" src="./images/comment3.png" alt=""/>
                <span>{{cooperate.experience}}</span>
              </div>
              <div class="tagItem">
                <span>数据效果：</span>
                <img v-if="cooperate.effect==='不满意'" src="./images/comment1.png" alt=""/>
                <img v-if="cooperate.effect==='需关注'" src="./images/comment2.png" alt=""/>
                <img v-if="cooperate.effect==='很满意'" src="./images/comment3.png" alt=""/>
                <span>{{cooperate.effect}}</span>
              </div>
            </div> 
          </div>
          <span class="title">评价内容</span>
          <p class="comment">{{cooperate.evaluation?cooperate.evaluation:'无'}}</p>
        </div>
        <div class="transform_content" style="margin-top: 30px;"> 
          <div class="title_box">
            <span class="title">互动数据</span>
          </div>
          <div class="sub_title interactionSubTitle" >包括本次投放的播放、点赞、评论、转发、主页导流水平</div>
          <div  class="interactionContent">
            <div class="interactionItem">
              <div class="interactionNum">{{ fmt(transform['live.spread.follow_uv'], {micrometer: true})||'-' }}</div>
              <div>新增粉丝数</div>
            </div>
            <div class="interactionItem">
              <div class="interactionNum">{{ fmt(transform['live.spread.comment_pv'], {micrometer: true})||'-' }}</div>
              <div>评论数</div>
            </div>
            <div class="interactionItem">
              <div class="interactionNum">{{ fmt(transform['live.spread.barrage_pv'], {micrometer: true})||'-' }}</div>
              <div>弹幕数</div>
            </div>
            <div class="interactionItem">
              <div class="interactionNum">{{ fmt(transform['live.spread.like_pv'], {micrometer: true})||'-' }}</div>
              <div>点赞数</div>
            </div>
            <div class="interactionItem">
              <div class="interactionNum">{{ fmt(transform['live.spread.share_pv'], {micrometer: true})||'-' }}</div>
              <div>分享数</div>
            </div>
            <div class="interactionItem">
              <div class="interactionNum">{{ fmt(transform['live.spread.watch_duration_avg'], {micrometer: true})||'-' }}s</div>
              <div>人均观看时长</div>
            </div>
          </div>
        </div>
        <div class="disseminate" id="transform">
          <div class="transform_content"> 
            <div class="title_box">
              <span class="title">转化漏斗</span>
            </div>
            <div class="sub_title interactionSubTitle" >包括本次投放的组件点击量、组件点击水平率</div>
            <div class="sub_title" style="margin-top:20px">APP安装完成成本
            <el-tooltip  effect="dark" content="任务金额/APP安装完成量(仅安包):APP安装完成量为0时，CPA设定为0" placement="top-start">
                  <i class="el-icon-question" style="margin-left:4px"></i>
            </el-tooltip>
            <!-- <span class="rate">￥{{transform.basicInfo.cpa||'-'}}</span> -->
            </div>
          <div class="transform_box">
            <div class="display_volume">
              <div class="blue_block first_block">
                <span>组件展现量</span>
              </div>
              <div class="transform_count_box">
                <div class="transform_count">{{fmt(transform['live.convert.component_show_cnt'], {micrometer: true})||'-'}}</div>
                <div class="sub_title">超过同行业<span class="rate">{{fmt(transform['live.convert.component_show_cnt_industry_over']*100, {micrometer: true})||'-'}}%</span>的订单</div>
              </div>
            </div>
            <div class="display_volume">
              <div class="blue_block second_block">
                <span>组件点击量</span>
              </div>
              <div class="transform_count_box">
                <div class="transform_count">{{fmt(transform['live.convert.component_click_cnt'], {micrometer: true})||'-'}}</div>
                <div class="sub_title">超过同行业<span class="rate">{{fmt(transform['live.convert.component_click_cnt_industry_over']*100, {micrometer: true})||'-'}}%</span>的订单</div>
              </div>
            </div>
            <div class="display_volume">
              <div class="blue_block third_block">
                <span>APP安装完成率(仅安卓)</span>
              </div>
              <div class="transform_count_box">
                <div class="transform_count">{{fmt(transform['live.convert.app_install_finish_cnt'], {micrometer: true})||'-'}}</div>
                <div class="sub_title">超过同行业<span class="rate">{{fmt(transform['live.convert.app_install_finish_cnt_industry_over']*100, {micrometer: true})||'-'}}%</span>的订单</div>
              </div>
            </div>
            <div class="solid1"></div>
            <div class="solid2"></div>
            <div class="solid3"></div>
            <div class="CTR_block">
              <div class="sub_title">点击率（CTR）</div>
              <div class="CTR_rate">{{fmt(transform['live.convert.component_ctr']*100, {micrometer: true})||'-'}}%</div>
              <div class="sub_title">超过同行业<span class="rate">{{fmt(transform['live.convert.component_ctr_industry_over']*100, {micrometer: true})||'-'}}%</span>的订单</div>
            </div>
            <div class="CVR_block">
              <div class="sub_title">转化率（CVR）</div>
              <div class="CTR_rate">{{fmt(transform['live.convert.app_cvr']*100, {micrometer: true})||'-'}}%</div>
              <div class="sub_title">超过同行业<span class="rate">{{fmt(transform['live.convert.app_cvr_industry_over']*100, {micrometer: true})||'-'}}%</span>的订单</div>
            </div>
            <div class="PVR_block">
              <div class="sub_title">展现转化率（PVR）</div>
              <div class="CTR_rate">{{fmt(transform['live.convert.app_pvr']*100, {micrometer: true})||'-'}}%</div>
              <div class="sub_title">超过同行业<span class="rate">{{fmt(transform['live.convert.app_pvr_industry_over']*100, {micrometer: true})||'-'}}%</span>的订单</div>
            </div>
          </div>
        </div>
      </div>
        <div class="transform_content" style="margin-top: 30px;"> 
          <div class="title_box">
            <span class="title">趋势分析</span>
            <el-dropdown trigger="click" @command="trendClick">
            <span class="el-dropdown-link">
              {{trendChecked}}<i class="el-icon-arrow-down el-icon--right"></i>
            </span>
            <el-dropdown-menu slot="dropdown">
              <el-dropdown-item v-for="(item,index) in baseInfo.items" :key="index" :command="item">{{ unixTime(item.create_time,'YYYY/MM/DD HH:mm:ss') }}</el-dropdown-item>
            </el-dropdown-menu>
          </el-dropdown>
          </div>
          <div class="sub_title interactionSubTitle" >展现直播间实时数据变化</div>
          <div  class="interactionContent">
            <div class="interactionItem">
              <div class="interactionNum">{{ fmt(trendAnalysis['live.spread.watch_uv'], {micrometer: true})||'-' }}</div>
              <div>累积观看人数</div>
            </div>
            <div class="interactionItem">
              <div class="interactionNum">{{ fmt(trendAnalysis['live.spread.watch_uv_max'], {micrometer: true})||'-' }}</div>
              <div>最高观看人数</div>
            </div>
            <div class="interactionItem">
              <div class="interactionNum">{{ fmt(trendAnalysis['live.spread.watch_acu'], {micrometer: true})||'-' }}</div>
              <div>平均在线人数</div>
            </div>
            <div class="interactionItem">
              <div class="interactionNum">{{parseInt(trendAnalysis['live.spread.watch_duration_avg']/60) + ":" +trendAnalysis['live.spread.watch_duration_avg']%60 ||'-' }}</div>
              <div>平均停留时长</div>
            </div>
          </div>
          <div class="trend_bar">
            <Bar :info="trendBar" isDisposeData></Bar>
          </div>
        </div>
      </div>

      <div class="disseminate" id="spectator">
        <div class="image_content">
          <div class="left_content">
            <div class="title_box">
              <span class="title">用户地域</span>
            </div>
            <div class="part5Chart1Container">
              <ChinaChart1 :chinaChartInfo="chinaChartInfo1" ref="detailPart5Chart1"></ChinaChart1>
            </div>

          </div> 
          <div class="right_content">
            <div class="title_box f-c-b">
              <span class="title">地域占比</span>
              <el-radio-group v-model="areaRadio" size="small">
                <el-radio-button label="province_distribution">省份</el-radio-button>
                <el-radio-button label="city_distribution">城市</el-radio-button>
              </el-radio-group>
            </div>
            <div class="sub_title">分布最多的3个{{areaRadio=='province_distribution'?'省份':'城市'}}为{{ regionData[0].key||''}}、{{regionData[1].key||''}}、{{ regionData[2].key||''}}</div>
            <div class="region_proportion_box">
              <div class="region_proportion_item" v-for="(item,index) in regionData" :key="index">
                <span class="region_proportion_text">{{ item.key }}</span>
                <div class="proportion_box">
                  <span class="proportion_content" :style="{width:item.width}"></span>
                  <span class="proportion_text" :style="{left:item.width}">{{item.value}}{{item.value?'%':''}}</span>
                </div>
              </div>
            </div>
          </div> 
        </div>
        <div class="image_content">
          <div class="left_content">
            <div class="title_box">
            <span class="title">性别分布</span>
            </div>
            <div class="sub_title">{{genderData[0].key=='male'?'男性':'女性'||''}}用户居多，占比{{genderData[0].value? genderData[0].value:0}}%</div>
            <div class="genderPie">
                <Pie :info="genderPie"></Pie>
              </div>
          </div> 
          <div class="right_content">
            <div class="title_box f-c-b">
              <span class="title">年龄占比</span>
            </div>
            <div class="sub_title">{{ ageBar.xAxis[0] }}用户居多，占比{{ ageBar.data[0].data[0] }}%</div>
            <div class="ageBar">
            <Bar :info = "ageBar" isDisposeData></Bar>
          </div>
          </div> 
        </div>

      </div>
    
    </div>
  </div>
  </div>
  
</template>

<script>
import contenr from "../content"
import ChinaChart1 from "../../components/Echart/ChinaChart1.vue";
import tools from "../../components/tools/tools.js";
import Radar from "../../components/newEchart/Radar.vue";
import Bar from "../../components/newEchart/Bar.vue";
import Pie from "../../components/newEchart/Pie.vue";
import WordCloud from "../../components/newEchart/WordCloud.vue";


export default {
  name: "Detail",
  props:[],
  components:{
    contenr,
    ChinaChart1,
    Radar,
    Bar,
    Pie,
    WordCloud,
  },
  data(){
    return {
      trendBar:{},
      trendRadio:'',
      itemid:'',
      origid:this.$route.query.origid,
      transform:{},
      trendAnalysis:{},
      genderData:{},
      create_timestamp:'',
      baseInfo:{},
      cooperate:{},
      vid:'',
      plattaskid:'',
      accountnumberId:'',
      ageBar:{},
      genderPie:{},
      regionData:[],
      areaRadio:'province_distribution',
      chinaChartInfo1:{
        nodeId:'detailPart5Echart1',//节点
        data: []//数据
      },
    }
  },
  computed:{
  },
  watch:{
    areaRadio(){
      this.getAudiencePortrait()
    }
  },
  created(){
    this.getCrmInfo()
    this.orderID = this.$route.query.id
  },
  methods:{
    handleErr(res){
     if(res.data.code !== 0){
      this.$message({
            message: res.data.error||'请稍后刷新重试',
            type: 'error'
          });
     }
    },
    trendClick(item){
      this.trendRadio = item.id
      this.trendChecked = this.unixTime(item.create_time,'YYYY/MM/DD HH:mm:ss') 
      this.getAgentLiveStat()
      this.getTrendAnalysis()
    },
    // tabChange(key,val){
    //   this[key] = val
    // },
    unixTime(time, formatStr='YYYY-MM-DD'){
      return this.dayjs.unix(time).format(formatStr)||'-'
    },
    maxScore(arr){
      if(!arr){
        return
      }else{
        let score = arr[3].split('-')[1]
        return score
      }

    },
    numChange(num){
      if(!num){
        return
      }
      if(num == "1"){
        return '不满意'
      }else if(num == "2"){
        return '需关注'
      }else if(num == "3"){
        return '很满意'
      }
    },
    getCrmInfo(){
      this.$axios.get(`api.php?m=index|api|gx&a=cooperationDetail&type=2&origid=${this.origid}`).then(res => {
        
        this.cooperate = res
        this.cooperate.effect = this.numChange(res.effect)
        this.cooperate.quality = this.numChange(res.quality)
        this.cooperate.experience = this.numChange(res.experience)
        this.accountnumberId = res.accountnumbername
        this.vid = res.vid
        this.plattaskid = res.plattaskid
        this.getBaseInfo()
        this.getTransform()
        this.getAudiencePortrait()
        

      }).finally(() => {
      })
    },
    getBaseInfo(){
      this.$axios.get(`agent-dlive?starid=${this.accountnumberId}&orderid=${this.plattaskid}`).then(res => {
        if(res.data.code!==0){
          this.handleErr(res)
          return
        }
      // this.$axios.get(`agent-dlive?starid=1726265453913102&orderid=7075692486559170568`).then(res => {
        let data = res?.data?.data
        this.baseInfo = data
        this.itemid = data?.item?.id
        this.trendRadio = data?.items[0].id
        this.trendChecked = this.unixTime(data?.items[0].create_time,'YYYY/MM/DD HH:mm:ss') 
        this.getAgentLiveStat()
        this.getTrendAnalysis()
        if(data?.items[0]?.create_time){
          this.create_timestamp = this.unixTime(data?.items[0]?.create_time)
        }

      }).finally(() => {
      })
    },
    getTransform(){
      this.$axios.get(`agent-live-convert?starid=${this.accountnumberId}&orderid=${this.plattaskid}`).then(res => {
    // this.$axios.get(`agent-live-convert?starid=1760583645624327&orderid=7211524637472063521`).then(res => {
      if(res.data.code!==0){
          this.handleErr(res)
          return
        }
      let data = res.data.data
      this.transform = data?.field_values||{}

      }).finally(() => {
      })
    },
    getTrendAnalysis(){
      this.$axios.get(`agent-live-item?starid=${this.accountnumberId}&itemid=${this.trendRadio}`).then(res => {
    // this.$axios.get(`agent-live-item?starid=17605836456243271&itemid=7212225936161327929`).then(res => {
      if(res.data.code!==0){
          this.handleErr(res)
          return
        }
      let data = res?.data?.data
      this.trendAnalysis = data?.field_values
      }).finally(() => {
      })
    },

    getAudiencePortrait(){
      this.$axios.get(`agent-live-distri?starid=${this.accountnumberId}&orderid=${this.plattaskid}`).then(res => {
    // this.$axios.get(`agent-live-distri?starid=1760583645624327&orderid=7211524637472063521`).then(res => {
      if(res.data.code!==0){
          this.handleErr(res)
          return
        }
      let data = res?.data?.data?.distribution
      if(data){
        if(this.areaRadio=='city_distribution'&&data?.city_distribution){
          data.city_distribution = data.city_distribution.filter(x=>x.key!="unknown")
          data.city_distribution.sort((a,b)=>b.value - a.value)
          let chinaCitySum = 0
          data?.city_distribution?.forEach((item,i)=>{
            chinaCitySum+=item.value?Number(item.value):0
          })
          this.regionData = data[this.areaRadio].map(x=>{          
            x.value = ((x.value/chinaCitySum)*100).toFixed(2)
            return x
            }).splice(0,9)
          this.regionData = this.regionData.map(x=>{
            x.width = x.value*6.7+'px'
            return x
          }) 
        }
        if(this.areaRadio=='province_distribution'&&data?.province_distribution){
          data.province_distribution = data.province_distribution.filter(x=>x.key!="unknown")
          data.province_distribution.sort((a,b)=>b.value - a.value)
          let chinaProvinceSum = 0
          data?.province_distribution?.forEach((item,i)=>{
          chinaProvinceSum+=item.value?Number(item.value):0
          })
          this.chinaChartInfo1.data = data?.province_distribution.map(x=>{
            return {name:x.key,value:((x.value/chinaProvinceSum)*100).toFixed(2)-0}
          })
          this.regionData = data[this.areaRadio].map(x=>{          
            x.value = ((x.value/chinaProvinceSum)*100).toFixed(2)
            return x
            }).splice(0,9)
          this.regionData = this.regionData.map(x=>{
            x.width = x.value*6.7+'px'
            return x
          })  
        }

        if(data.gender_distribution){
          this.genderData = data.gender_distribution
          this.genderPie = {
            name: '性别分布',
            radius: ['50%', '70%'], // 格式：['40%', '70%']
            showLabel: true,  // 默认为true
            showPercent: false,
            showLabelRate: 5, //比率大于百分之5的时候展示label
            data: [],
            custom: {
                    legend: false,
                    tooltips:{
                      show:false
                    }
                  }
          } 
        }

        if(data.gender_distribution){
          data.gender_distribution = data.gender_distribution.filter(x=>{
            if(x.key ==='male'|| x.key === 'female'){
              return x
            }
          })
          let sum = 0
          data.gender_distribution.forEach(x=>{
            sum+= x.value?Number(x.value):0
          if(x.key==='male'){
            x.name = '男性占比'
            x.color ='#4D93FF'
           }else if(x.key === 'female'){
            x.name = '女性占比'
            x.color = '#F76C42'
           }
          })
          this.genderPie.data = data.gender_distribution.map(x=>{
            x.value = ((x.value/sum)*100).toFixed(2)
            return x
          })

        }
        if(data.age_distribution){
          data.age_distribution = data.age_distribution.filter(x=>{
            if(x.key!=='-18'&&x.key!=="unknown"){
              return x
            }
          })
          data.age_distribution.sort((a,b)=>b.value - a.value)
          let sum = 0
          data.age_distribution.forEach(x=>{
            sum+= x.value?Number(x.value):0
          })
          this.ageBar = {
              xAxis: [],
              data: [
                { 
                  stack: '年龄占比',
                  color: '#4D93FF',
                  barWidth: 20,
                  name: '年龄占比',
                  data: [],
                  type: 'bar',
                  symbol: 'none',
                  itemStyle: {
                    borderRadius: [10, 10, 0, 0],
                  }
                },
              ],
              custom: {
                legend: false,
                yAxis:{
                    name:'百分比',
                    axisLabel:{
                      formatter:'{value}%'
                    }
                  }
              }
          }
          this.ageBar.xAxis = data.age_distribution.map(x=>x.key) 
          this.ageBar.data[0].data = data.age_distribution.map(x=>((x.value/sum)*100).toFixed(2)) 
        }
       

      }


      }).finally(() => {
      })
    },
    getAgentLiveStat(){
      let url =`agent-live-stat?starid=${this.accountnumberId}&orderid=${this.plattaskid}&itemid=${this.trendRadio}`
      this.$axios.get(url).then(res => {
    // this.$axios.get(`agent-live-stat?itemid=7212225936161327929&starid=1760583645624327&orderid=7211524637472063521`).then(res => {
      if(res.data.code!==0){
          this.handleErr(res)
          return
        }
      let data = res?.data?.data?.stat_list
      if(data){
        this.trendBar = {
              xAxis: [],
                data: [
                { 
                    stack: '在线人数',
                    color: '#3F90FD',
                    barWidth: 20,
                    name: '在线人数',
                    data: [],
                    type: 'line',
                    symbol: 'none',
                  },
                { 
                    stack: '新增粉丝数',
                    color: '#FC3C74',
                    barWidth: 20,
                    name: '新增粉丝数',
                    data: [],
                    type: 'line',
                    symbol: 'none',
                  },
                { 
                    stack: '弹幕数',
                    color: '#FFA940',
                    barWidth: 20,
                    name: '弹幕数',
                    data: [],
                    type: 'line',
                    symbol: 'none',
                  },
                { 
                    stack: '点赞数',
                    color: '#88CB6E ',
                    barWidth: 20,
                    name: '点赞数',
                    data: [],
                    type: 'line',
                    symbol: 'none',
                  },

                ],
                custom: {
                  dataZoom: [
                    {
                      type: 'inside',
                      start: 0,
                      end: 100, 
                    },
                    {
                      start: 0,
                      end: 100, 
                      bottom: 0,
                      height: 20,
                      fillerColor: '#3377FF',
                      backgroundColor: "#E8EBF3",
                      showDetail: true,
                    }
                  ],
                  xAxis:{
                    axisLabel: {
                      interval: "auto",
                    }
                  }
                }
              }
        this.trendBar.xAxis = data.map(x=>{
          x.time = this.unixTime(x.time,'MM/DD HH:mm')
          return x.time
        })
        let arr = ['play_incr','fans_club_incr','barrage_incr','like_incr']
        this.trendBar.data.forEach((x,i)=>{
            x.data = data.map(x=>x[arr[i]])
        })
      }



      }).finally(() => {
      })
    },



    //三位数以上加逗号
    toThousands(num) {
      var num = (num || 0).toString(), result = '';
      while (num.length > 3) {
          result = ',' + num.slice(-3) + result;
          num = num.slice(0, num.length - 3);
      }
      if (num) { result = num + result; }
      return result;
    },
    toChangeW(num){
      if(num > 9999){
        return (Math.floor(num/1000)/10) + 'w'
      }
      return num
    },
  },

  mounted(){


    
  }
}
</script>

<style scoped>
.f-c-b{
  display: flex; 
  align-items: center;
  justify-content: space-between
}
.page{
  width: 1820px;
  margin: 20px auto;
  display: flex;
  padding: 30px;
  background-color: #fff;
}
.detailContainer{
  width: 1760px;
  padding-left: 30px;
}
.infoText{
  width: 100%;
  font-size: 12px;
  font-family: OPPOSans;
  color: #999999;
  padding: 15px 0 30px 0;
}
.headSculpture{
 display: flex;
 align-items: center;
}
.headSculpture img{
  width: 30px;
  height: 30px;
  border-radius: 50%;
}
.headSculpture .nickname{
  font-size: 12px;
  font-family: OPPOSans;
  font-weight: 500;
  color: #9D9D9D;
  margin-left: 8px;
}
.interactionContent{
  display: flex;
  align-items:center;
}
.interactionSubTitle{
  padding: 15px 0 20px 0;
  border-bottom: 1px solid #EFF1F1;
}
.interactionItem{
  position: relative;
  width: 158px;
  font-size: 12px;
  font-family: OPPOSans;
  font-weight: 500;
  color: #999999;
  padding: 30px 0 0 30px;
}
.interactionItem:first-child{
  padding-left: 0px;

}
.interactionItem:after{
  content:'';
  position: absolute;
  right: 0;
  top: 30px;
  width: 1px;
  height: 40px;
  background: #EFF1F1;
}
.interactionItem:last-child:after{
  display: none;
}
.interactionNum{
  font-size: 20px;
  font-family: OPPOSans;
  font-weight: 800;
  color: #333333;
}
.trend_bar{
  height: 350px;
}
.orderInfo{
  border-bottom: 1px solid #EFF1F1;
}
  .part1 .grade{
    margin-top: 30px;
    width: 100%;
    background: #FFFFFF;
    padding: 30px;
    border: 1px solid #EFF1F1;
    box-sizing: border-box;
    border-radius: 8px;
    line-height: 0px;
  }
  .part1 .grade .title,.synthesize .title,.disseminate .title{
    margin: 10px 0;
    font-size: 16px;
    font-family: OPPOSans;
    font-weight: 700;
    color: #333333;
  }
  .part1 .grade .comment{
    width: 100%;
    background: #F8F8F8;
    border-radius: 6px;
    padding: 20px 30px;
    font-size: 16px;
    font-family: OPPOSans;
    font-weight: 500;
    color: #888888;
    line-height: 32px;
    margin-bottom:0;
    box-sizing: border-box;
  }

  .part1 .grade .gradeContent{
    width: 100%;
    height: 160px;
  }
  .part1 .grade .gradeContent .scort{
    padding-top: 45px;
    padding-bottom: 40px;
    height: 60px;
    box-sizing: border-box;
    width: 360px;
    margin: 0 auto;
  }
  .part1 .grade .gradeContent .scort>>>.el-rate__icon{
    font-size: 60px;
  }
  .part1 .grade .gradeContent .scort>>>.el-rate__text{
    font-size: 40px;
  }

  .part1 .grade .gradeContent .tags2{
    display: flex;
    justify-content: space-between;
    width: 100%;
    padding: 0 390px;
    box-sizing: border-box;
    
  }

  .part1 .grade .gradeContent .tags2 .tagItem{
    margin-top: 40px;
    width: 260px;
  }
  .part1 .grade .gradeContent .tags2 .tagItem span:nth-of-type(1){
    float: left;
    font-size: 20px;
    font-family: OPPOSans;
    font-weight: 500;
    color: #666666;
    line-height: 36px;
  }
  .part1 .grade .gradeContent .tags2 .tagItem span:nth-of-type(2){
    float: left;
    font-size: 20px;
    font-family: OPPOSans;
    font-weight: 500;
    color: #FF9A16;
    line-height: 36px;
  }
  .part1 .grade .gradeContent .tags2 .tagItem img{
    float: left;
    display: inline-block;
    width: 36px;
    height: 36px;
    margin-left: 17px;
    margin-right: 11px;
  }
  .synthesize>>>.el-progress__text{
    font-size: 12px !important;
    font-family: OPPOSans;
    font-weight: 700;
    color: #333333 !important;
  }
  .synthesize>>>.el-progress-bar__inner{
    background-image: linear-gradient(to right, #1171FF  0%, #0AA1F8  100%)
  }
  .synthesize_content,.disseminate_content,.touchReach_content,.brand_image_content, .transform_content{
    /* width: 1610px; */
    background: #FFFFFF;
    border: 1px solid #EFF1F1;
    border-radius: 8px;
    padding: 20px 30px 30px 30px;
    margin-bottom: 30px;
  }
  .title_box .title{
    font-size: 16px;
    font-family: OPPOSans;
    font-weight: 700;
    color: #333333;
    margin:0px;
  }
  .title_box .subTitle{
    font-size: 14px !important;
    font-family: OPPOSans;
    font-weight: 700;
    color: #333333;
    line-height: 32px;
    margin:0px;
  }
  .synthesize_content .content_box{
    display: flex;
  }
  .synthesize_content .title_box .score{
    margin-left: 10px;
    font-size: 18px;
    font-family: OPPOSans;
    font-weight: bold;
    color: #FF5C00;
  }
  .synthesize_content .title_box .score_text{
    font-size: 14px;
  }
  .synthesize_content .radar_box{
    width: 340px;
    height: 220px;
    border-right: 1px solid #EFF1F1;
    padding-right: 40px;
  }
  .synthesize_content .progress_box{
    padding: 10px 0 0 40px;
    width: 100%;
  }
  .synthesize_content .grade_box{
    width: calc(100% - 155px) ;
    margin-left: 90px;
    display: flex;
    justify-content: space-between;
    font-size: 12px;
    font-family: OPPOSans;
    font-weight: 700;
    color: #666666;
    margin-bottom: 40px;
  }
  .synthesize_content .grade_box:last-child{
    margin-bottom: 0px;
  }
  .synthesize_content .progress_box .progress_item{
   display: flex;
   align-items: center;
   margin-bottom: 8px;
  }
  .progress_box .progress_item .progress_title{
    font-size: 12px;
    font-family: OPPOSans;
    font-weight: 700;
    color: #333333;
  }
  .synthesize_content .progress_box .progress{
    display: flex;
    align-items: center;
    width: 92%;
    margin-left: 20px;
    height: 22px;
  }
  .disseminate_content>>>.vxe-radio-group{
    width: 300px;
  }
  .disseminate_content .title_box,.touchReach_content .title_box,.brand_image_content .title_box, .transform_content .title_box{
    display: flex;
    justify-content:space-between;
  }
  .disseminate_mid{
    width: 1550px;
    height: 100px;
    background: #F9F9F9;
    border-radius: 8px;
    display: flex;
    margin-top: 24px;
  }
  .costPerformance_mid{
    width: 100%;
    height: 110px;
  }
  .disseminate_mid_title{
    text-align: center;
    font-size: 12px;
    font-family: OPPOSans;
    font-weight: 500;
    color: #666666;
  }
  .disseminate_mid_item{
    position: relative;
    width: 386px;
    padding: 25px 0 35px 0;
  }
  .costPerformance_mid_item{
    position: relative;
    width: 365px;
    padding: 21px 0 17px 0;
  }
  .disseminate_count{
    text-align: center;
    font-size: 18px;
    font-family: OPPOSans;
    font-weight: bold;
    color: #333333;
    margin-top: 8px;
  }
  .disseminate_mid_item:after{
    position: absolute;
    content: "";
    width: 1px;
    height: 30px;
    background: #DDDDDD;
    top: 35px;
    left: 386px;
  }
  .costPerformance_mid_item:after{
    position: absolute;
    content: "";
    width: 1px;
    height: 50px;
    background: #DDDDDD;
    top: 30px;
    left: 100%;
  }
  .disseminate_mid_item:last-child:after,.costPerformance_mid_item:last-child:after{
    display: none;
  }
  .disseminate_content_top{
    display: flex;
    justify-content: space-between;
    padding: 30px 0;
  }
  .disseminate_content .content_box .bar_box{
    width: 100%;
    height: 375px;
  }
  .touchReach_content .touchReach_content_box{
    display: flex;
  }
  .touchReach_content .touchReach_content_box .touchReach_pie{
    width: 310px;
    height: 400px;
  }
  .touchReach_content_box .list_head,.touchReach_content_box .list_item{
    display: flex;
    justify-content:space-between;
    padding: 18px 0;
    border-bottom: 1px solid #EFF1F1;
  }
  .touchReach_content_box .list_box{
    width: calc(100% - 310px);
    font-size: 12px;
    font-family: OPPOSans;
    font-weight: 700;
    color: #333333;
  }
  .touchReach_content_box .list_box .Block{
    display: block;
    width: 12px;
    height: 12px;
    border-radius: 4px;
  }
  .color0{
    background: #1C7CFC;
  }
  .color1{
    background: #3E92FF;
  }
  .color2{
    background: #42A6FE;
  }
  .color3{
    background: #73C2FF;
  }
  .color4{
    background: #88CBFF;
  }
  .color5{
    background: #ABD8FF;
  }
  .color6{
    background: #DBF0FF;
  }
  .fist_block{
    display: flex;
    align-items: center;
  }
  .fist_block .fist_text{
    margin-left: 4px;
  }
  .costPerformance{
   display: flex;
   justify-content: space-between;
  }
  .left_content,.right_content{
    width: calc(calc(100% - 30px) / 2);
    box-sizing: border-box;
    border: 1px solid #EFF1F1;
    padding: 30px;
    border-radius: 8px;
    margin-bottom: 30px;
  }
  .costPerformance_bar{
   height: 260px;
  }
  .viewers_bar{
    margin-top: 20px;
    height: 350px;
  }
 .brand{
    font-size: 14px;
    font-family: OPPOSans;
    font-weight: 400;
    color: #333333;
    text-align: right;
  }
  .search_bar{
    height: 420px;
  }


  .image_content{
    display: flex;
    justify-content: space-between;
  }
  .appraise_list{
    margin-top: 20px;
    height: 550px;
    overflow-y:scroll;
  }
  .appraise_item{
    margin-bottom: 30px;
    display: flex;
    justify-content: space-between;
  }
  .appraise_image{
    width: 40px;
    height: 40px;
    border-radius: 50%;
  }
  .appraise_nick{
    font-size: 12px;
    font-family: OPPOSans;
    font-weight: 400;
    color: #333333;
  }
  .appraise_time{
    font-size: 12px;
    font-family: OPPOSans;
    font-weight: 400;
    color: #999999;
    margin-left: 10px;
  }
  .appraise_left, .appraise_rigth{
    display: flex;
    padding-right: 50px;
  }
  .appraise_content{
    padding-top: 5px;
    width: 434px;
    font-size: 16px;
    font-family: OPPOSans;
    font-weight: 700;
    color: #333333;
    margin:0px;
  }
  .heart{
    display: block;
    width: 18px;
    height: 16px;
    background:url('./images/heart.png') no-repeat;
    background-size: 100%;
  }
  .heart_num{
    font-size: 14px;
    font-family: OPPOSans;
    font-weight: 800;
    color: #333333;
    margin-left: 12px;
  }
  .midbox{
    margin-left: 12px;
  }
  .transform_box{
    position: relative;
    padding:50px  570px 43px 190px;
  }
  .display_volume{
    position: relative;
    width: 500px;
    height: 90px;
    background: #FAFAFA;
    font-size: 14px;
    font-family: OPPOSans;
    font-weight: 700;
    color: #FFFFFF;
    margin-bottom: 20px;
  }
  .blue_block{
    display: flex;
    align-items: center;
    padding-left: 20px;
    box-sizing: border-box;
    position: absolute;
    left: 0;
    top: 0;
    height: 90px;
    /* background: linear-gradient(#0AA1F8,#1171FF); */
    background: linear-gradient(-70deg,transparent 30px,#0AA1F8 0,#1171FF);
  }
  .first_block{
    width: 260px;
  }
  .second_block{
    width: 230px;
  }
  .third_block{
    width: 200px;
  }
  .transform_count{
    text-align: right;
    margin-bottom: 7px;
    font-size: 16px;
    font-family: OPPOSans;
    font-weight: 800;
    color: #333333;
  }
  .transform_count_box{
    position: absolute;
    right: 30px;
    top: 22px;
  }
  .solid1{
    position: absolute;
    top: 100px;
    left: 690px;
    width: 20px;
    height: 102px;
    border-top-right-radius: 4px;
    border-bottom-right-radius: 4px;
    border-top: 1px dashed #1878FC;
    border-right: 1px dashed #1878FC;
    border-bottom: 1px dashed #1878FC;
  }
  .solid2{
    position: absolute;
    top: 216px;
    left: 690px;
    width: 20px;
    height: 102px;
    border-top-right-radius: 4px;
    border-bottom-right-radius: 4px;
    border-top: 1px dashed #1878FC;
    border-right: 1px dashed #1878FC;
    border-bottom: 1px dashed #1878FC;
  }
  .solid3{
    position: absolute;
    top: 76px;
    left: 690px;
    width: 196px;
    height: 262px;
    border-top-right-radius: 4px;
    border-bottom-right-radius: 4px;
    border-top: 1px dashed #1878FC;
    border-right: 1px dashed #1878FC;
    border-bottom: 1px dashed #1878FC;
  }
  .CTR_block{
    width: 140px;
    height: 100px;
    display: flex;
    justify-content:space-around;
    align-items: center;
    flex-direction: column;
    position: absolute;
    left: 730px;
    top: 100px;
  }
  .CVR_block{
    width: 140px;
    height: 100px;
    display: flex;
    justify-content:space-around;
    align-items: center;
    flex-direction: column;
    position: absolute;
    left: 730px;
    top: 216px;
  }
  .PVR_block{
    width: 140px;
    height: 100px;
    display: flex;
    justify-content:space-around;
    align-items: center;
    flex-direction: column;
    position: absolute;
    left: 917px;
    top: 170px;

  }
  .spectator_box{
    position: relative;
    margin-top: 30px;
    height: 400px;
  }
  .ageBar{
    margin-top: 30px;
    height: 270px;
  }
  .spectator_brand{
    position: absolute;
    top: 0;
    right: 0;
    font-size: 14px;
    font-family: OPPOSans;
    font-weight: 400;
    color: #333333;
  }
  .region_proportion_box{
    margin-top: 16px;
  }
  .region_proportion_item{
    margin-top: 14px;
    display: flex;
    align-items: center;
  }
  .region_proportion_text{
    margin-right: 13px;
    font-size: 12px;
    font-family: OPPOSans;
    font-weight: 400;
    color: #666666;
  }
  .proportion_box{
    position: relative;
    display: flex;
    width: 670px;
    height: 18px;
    background: #ECF6FF;
  }
  .proportion_content{
    display: block;
    height: 18px;
    background: linear-gradient(90deg, #40A5FF, #40A5FF);
  }
  .proportion_text{
    position: absolute;
    font-size: 12px;
    font-family: OPPOSans;
    font-weight: 500;
    color: #333333;
  }
  .genderPie{
    height: 240px;
  }


  .detailContainer>>>.el-tabs__nav-wrap::after{
    background-color:transparent;
    border-bottom: 1px solid #F5F5F6;
  }
  .detailContainer>>>.el-tabs__item{
    color:#999;
  }
  .detailContainer>>>.el-tabs__item.is-active{
    color: #FF5C00;
  }
  .detailContainer>>>.el-tabs__active-bar{
    background-color:#FF5C00;
  }

  .part .hr{
    width: 1200px;
    height: 1px;
    margin-left: -30px;
    border-bottom: 1px solid #F5F5F6;
  }


  .clear:after {
    /*伪元素是行内元素 正常浏览器清除浮动方法*/
    content: "";
    display: block;
    height: 0;
    clear: both;
    visibility: hidden;
  }

  .clear {
    *zoom: 1;
    /*ie6清除浮动的方式 *号只有IE6-IE7执行，其他浏览器不执行*/
  }
  .detailContainer .part{
    width: 100%;
    background: #FFFFFF;
    box-sizing: border-box;
  }
  .detailContainer .part1{
    overflow: hidden;
  }
  .part1 .topName{
    font-size: 16px;
    font-family: PingFang SC;
    font-weight: bold;
    color: #333333;
  }
  .part1 .infoContent{
    display: flex;
    /* width: 100%; */
    margin-top: 30px;
  }
  .part1 .infoContent .backImg{
    position: relative;
    width: 126px;
    height: 126px;
    border-radius: 10px;
    overflow: hidden;
    cursor: pointer;
  }
  .part1 .infoContent .backImg::before{
    content: '';
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background: rgba(0, 0, 0, .3);
  }
  .part1 .infoContent .backImg::after{
    content: '';
    position: absolute;
    top: 0;
    bottom: 0;
    left: 0;
    right: 0;
    width: 40px;
    height: 40px;
    margin: auto;
    background: url("./images/icon_play.png") no-repeat center;
    background-size: cover;
  }
  .part1 .infoContent .backImg img{
    display: block;
    width: 100%;
    height: 100%;
  }
  .part1 .infoContent .contentDetail{
    /* float: left; */
    margin-left: 30px;
    width: 100%;
  }
  .part1 .infoContent .contentDetail{
    display: flex;
    justify-content: space-between;
  }
  .contentDetail .contentTitle{
    font-size: 16px;
    font-family: OPPOSans;
    font-weight: 700;
    color: #333333;
    line-height: 32px;
  }
  .part1 .infoContent .contentDetail a{
    display: block;
  }
  .part1 .infoContent .contentDetail p a{
    display: -webkit-box;
    -webkit-box-orient: vertical;
    -webkit-line-clamp: 2;
    overflow: hidden;
    font-size: 14px;
    font-family: PingFang SC;
    font-weight: 500;
    color: #333333;
    line-height: 24px;
  }
  .part1 .infoContent .contentDetail span a{
    font-size: 12px;
    font-family: PingFang SC;
    font-weight: 500;
    color: #999999;
  }
  .part1 .infoContent .contentBottom{
    display: flex;
    justify-content:space-between;
  }
  .part1 .infoContent .contentBottom .infoItem{
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    align-items: center;
    margin-left: 40px;
  }
  .part1 .infoContent .contentBottom .infoItem span{
    /* width: 140px;
    height: 48px; */
    font-size: 12px;
    color: #333333;

  }
  .part1 .infoContent .contentBottom .infoItem .account{
    font-size: 20px;
    font-family: OPPOSans;
    font-weight: bold;
    color: #333333;
  }
  .scale{
    color: #999999;
    text-align: center;
    font-size: 12px;
    margin-top: 8px;
  }
  .sub_title{
    color: #999999;
    font-size: 12px;
    margin-top: 17px;
  }
  .scale .rate,.sub_title .rate{
    color: #FF5C00 !important;
    font-weight: 700;
    margin-left: 2px;
  }


  .part5Chart1Container{
    float: left;
    position: relative;
    width: 50%;
  }
  .part5Chart1Container .left{
    position: absolute;
    bottom: 30px;
    left: 30px;
    width: 12px;
    height: 84px;
    background-image: linear-gradient(to bottom, #38a1ff, #e0f1ff);
  }
  .part5Chart1Container .left::before{
    content: "高";
    position: absolute;
    bottom: 90px;
    left: 0px;
    font-size: 14px;
    font-family: OPPOSans;
    font-weight: 500;
    color: #333333;
  }
  .part5Chart1Container .left::after{
    content: "低";
    position: absolute;
    bottom: -24px;
    left: 0px;
    font-size: 14px;
    font-family: OPPOSans;
    font-weight: 500;
    color: #333333;
  }
  #detailPart5Echart1{
    width: 570px;
    height: 260px;
  }
</style>